import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

export type PanelCreditsProps = PanelCreditsDto;
const styles = {
    container: {}
};

type Props =
    PanelCreditsProps &
    StyledComponentProps<keyof typeof styles>;

const PanelCredits = (props: Props) => {
    const { classes } = props;
    return (
        <div className={classes!.container} dangerouslySetInnerHTML={{ __html: props.Credits }} />
    );
}

export default withStyles(styles)(PanelCredits);


// WEBPACK FOOTER //
// ./src/components/PanelCredits.tsx